import { useState, useEffect } from 'react';

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
/**
 * Components that depend on specific browser APIs
 * such as `window`, `document`, `Element` will throw
 * errors in a NodeJS (server side) environment
 * because these APIs are unavailable.
 *
 * We should use a guard check to prevent unexpected
 * errors being thrown server-side when trying to
 * render components or invoke methods that reference
 * these unavailable APIs.
 */

function isServerSide() {
  return typeof window === 'undefined';
}

var useIsServerSide = function useIsServerSide() {
  // Always assume by default that the environment is ssr, this is done
  // to ensure that any initial renders match the output of a SSRed view
  var _useState = useState(true),
      _useState2 = _slicedToArray(_useState, 2),
      isSsr = _useState2[0],
      setIsSsr = _useState2[1];

  useEffect(function () {
    // A `useEffect` will only ever run on the client and never on a server.
    // so we can safely assume that if we are within this hook we are on the
    // client and thus we are not doing an ssr and the DOM should be available.
    setIsSsr(isServerSide());
  }, []);
  return isSsr;
};

export { isServerSide, useIsServerSide };
